import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import UsersSection from "./users-section";

export default function UsersPage() {
  return (
    <>
      <Header />
      <UsersSection />
    </>
  );
}
